module.exports = __webpack_public_path__ + "img/Weapon_287.02e9db3e.png";